/* eslint-disable no-magic-numbers */
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

type FormatOption =
  | 'amount'
  | 'amount_no_decimals'
  | 'amount_with_comma_separator'
  | 'amount_no_decimals_with_comma_separator'
  | 'amount_with_apostrophe_separator';

const formatMoney = (cents: number | string, format = '£{{amount}}'): string => {
  if (typeof cents === 'string') {
    cents = parseInt(cents.replace('.', ''), 10);
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const match = format.match(placeholderRegex);

  if (!match) {
    console.warn('Invalid format string:', format);
    return '';
  }

  const formatKey = match[1] as FormatOption;
  const formatWithDelimiters = (
    number: number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ): string => {
    if (isNaN(number) || number === null) return '0';

    const formatted = (number / 100).toFixed(precision);
    const [whole, fraction] = formatted.split('.');
    const pounds = whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, `£1${thousands}`);
    const cents = fraction ? decimal + fraction : '';

    return pounds + cents;
  };

  let value = '';

  switch (formatKey) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, '\'', '.');
      break;
    default:
      console.warn('Unknown format key:', formatKey);
      value = formatWithDelimiters(cents, 2);
  }

  return format.replace(placeholderRegex, value);
};

export default formatMoney;
